import { fetchInstance } from 'rest/dist/utils/fetchInstance';

export function fetchAnalyticsOrders({
  fromDate,
  toDate,
  campaignIds,
  hasShipping,
  minDiscount,
  search,
  page = 1,
  limit = 20,
} = {}) {
  const params = { page, limit };
  if (fromDate)               params.fromDate   = fromDate;
  if (toDate)                 params.toDate     = toDate;
  if (campaignIds?.length)    params.campaignIds = campaignIds.join(',');
  if (hasShipping)            params.hasShipping = true;
  if (minDiscount != null && minDiscount > 0) params.minDiscount = minDiscount;
  if (search)                 params.search     = search;

  return fetchInstance({ url: '/api/analytics/orders', method: 'get', params });
}

// Cheap all-time "has this shop ever had an order" check — use this instead
// of fetchAnalyticsOrders({page:1, limit:1}) when total/data/summary aren't
// needed. That call still runs an unbounded count + full revenue/discount
// aggregate over the shop's entire order history server-side regardless of
// `limit`; this endpoint does a single indexed existence check instead.
export function checkHasAnyOrders() {
  return fetchInstance({ url: '/api/analytics/orders/has-any', method: 'get' });
}
